import { LatLngModel } from "front-end/services/geolocation/models/lat-lng.model";
import { userGeoLocationService } from "front-end/services/geolocation/user-geo-location.service";
import _round from "lodash/round";

// TODO-TD: review the usage of the service bellow, remove duplicated code (see angular store-locator-search.component), create shared service?

export class GeoDistanceService {
    private _distanceUnit: string;
    private _geoDistances: JQuery<HTMLElement> = $();

    private _classMap = {
        js: {
            geoDistance: ".js-ina-geo-distance"
        }
    };

    private updateDistance(userLocation: LatLngModel): void {
        if(userLocation) {
            this.setDistance(userLocation);
        } else {
            this.clearDistane();
        }
    }

    private setDistance(userLocation: LatLngModel) : void {
        this._geoDistances.each((index: number, element: HTMLElement) => {
            const $element = $(element);
            const targetLocation = $element.data() as LatLngModel;
            const distance = this.calculateDistance(userLocation, targetLocation).toFixed(1);

            $element.text(`(${distance} ${this._distanceUnit})`);
            $element.show();
        });
    }

    private clearDistane(): void {
        this._geoDistances.each((index: number, element: HTMLElement) => {
            const $element = $(element);
            $element.text("");
            $element.hide();
        });
    }

    private calculateDistance(userLocation: LatLngModel, targetLocation: LatLngModel): number {
        // NOTE: source cloud.google.com/blog/products/maps-platform/how-calculate-distances-map-maps-javascript-api

        const R = 3959; // Radius of the Earth in miles
        const rlat1 = userLocation.lat * (Math.PI/180); // Convert degrees to radians
        const rlat2 = targetLocation.lat * (Math.PI/180); // Convert degrees to radians
        const difflat = rlat2-rlat1; // Radian difference (latitudes)
        const difflon = (targetLocation.lng - userLocation.lng) * (Math.PI/180); // Radian difference (longitudes)

        const d = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat/2)*Math.sin(difflat/2)+Math.cos(rlat1)*Math.cos(rlat2)*Math.sin(difflon/2)*Math.sin(difflon/2)));

        return _round(d, 1);
    }

    private bindEvents(): void {
        userGeoLocationService.getInitialLocation()
            .subscribe(location => this.updateDistance(location));

        userGeoLocationService.watchCurrentLocation()
            .subscribe(location => this.updateDistance(location));
    }

    private initContext(): void {
        this._geoDistances = $(this._classMap.js.geoDistance, $(document));
    }

    public init(distanceUnit: string): void {
        this._distanceUnit = distanceUnit;

        this.initContext();
        this.bindEvents();
    }
}
